import PropTypes from 'prop-types';
import React, { createContext, useContext, useMemo, useState, useCallback } from 'react';

const PickupContext = createContext();

export function PickupProvider({ children }) {
  const [tillNumber, setTillNumber] = useState('');
  const [tenders, setTenders] = useState([]);
  const [backToTillSummaryEnabled, setBackToTillSummaryEnabled] = useState(false);
  const [submitError, setSubmitError] = useState('');
  const [submitSuccess, setSubmitSuccess] = useState('');
  const [submitLoading, setSubmitLoading] = useState('');
  const [submitDisabled, setSubmitDisabled] = useState(false);

  const setNewTenders = useCallback((newTenders) => {
    setTenders(newTenders);
  }, []);

  const updateTender = useCallback((updatedTender) => {
    setTenders((prevTenders) =>
      prevTenders.map((tender, i) => (i === updatedTender.index ? updatedTender : tender)),
    );
  }, []);

  const value = useMemo(
    () => ({
      tillNumber,
      setTillNumber,
      tenders,
      setNewTenders,
      updateTender,
      backToTillSummaryEnabled,
      setBackToTillSummaryEnabled,
      submitError,
      setSubmitError,
      submitSuccess,
      setSubmitSuccess,
      submitLoading,
      setSubmitLoading,
      submitDisabled,
      setSubmitDisabled,
    }),
    [
      tillNumber,
      setTillNumber,
      tenders,
      setNewTenders,
      updateTender,
      backToTillSummaryEnabled,
      setBackToTillSummaryEnabled,
      submitError,
      setSubmitError,
      submitSuccess,
      setSubmitSuccess,
      submitLoading,
      setSubmitLoading,
      submitDisabled,
      setSubmitDisabled,
    ],
  );

  return <PickupContext.Provider value={value}>{children}</PickupContext.Provider>;
}

PickupProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export const usePickupContext = () => useContext(PickupContext);

export const useTillNumber = () => {
  const { tillNumber, setTillNumber } = useContext(PickupContext);
  return { tillNumber, setTillNumber };
};

export const useTenders = () => {
  const { tenders, setNewTenders, updateTender } = useContext(PickupContext);
  return { tenders, setNewTenders, updateTender };
};

export const useBackToTillSummaryEnabled = () => {
  const { backToTillSummaryEnabled, setBackToTillSummaryEnabled } = useContext(PickupContext);
  return { backToTillSummaryEnabled, setBackToTillSummaryEnabled };
};

export const useSubmitError = () => {
  const { submitError, setSubmitError } = useContext(PickupContext);
  return { submitError, setSubmitError };
};

export const useSubmitSuccess = () => {
  const { submitSuccess, setSubmitSuccess } = useContext(PickupContext);
  return { submitSuccess, setSubmitSuccess };
};

export const useSubmitLoading = () => {
  const { submitLoading, setSubmitLoading } = useContext(PickupContext);
  return { submitLoading, setSubmitLoading };
};

export const useSubmitDisabled = () => {
  const { submitDisabled, setSubmitDisabled } = useContext(PickupContext);
  return { submitDisabled, setSubmitDisabled };
};
